import React from "react";
import Container from "react-bootstrap/Container";
export default function MyFooter(props) {
  return (
    <>
      <footer>
        <Container>
          <div className="foot_body">
            <p>Copyright © 2025 WINCHO</p>
            <p>Wincho version- Beta0.10</p>
            <p className="">
              <a href="/privacy">Privacy Policy</a> |{" "}
              <a href="/Terms">Terms and condition</a>
            </p>
          </div>
        </Container>
      </footer>
    </>
  );
}
